import { useEffect, useMemo, useRef, useState } from "react";
import { parseUnits } from "ethers"; // v6
// import { parseUnits } from "viem"; // if you prefer viem
// import { formatUnits } from "ethers"; // for UI formatting if neededS

export function useDebouncedMintQuote({
  token0,
  token1,
  fee,
  tickLower,
  tickUpper,
  side, // "0" = user types token0, "1" = user types token1
  amountInput, // raw string from <input>
  dec0,
  dec1,
  delay = 350, // ms
  quoter, // your quoteMintAmountsGivenOneSide function
}) {
  const [loading, setLoading] = useState(false);
  const [quote, setQuote] = useState(null);
  const [error, setError] = useState(null);

  const seqRef = useRef(0);

  // safe parse without throwing on "", ".", etc.
  const amountWei = useMemo(() => {
    const s = (amountInput ?? "").trim().replace(/,/g, "");
    if (!s) return 0n;
    try {
      return parseUnits(s, side === "0" ? dec0 : dec1);
    } catch {
      return null; // invalid typing in progress
    }
  }, [amountInput, side, dec0, dec1]);

  useEffect(() => {
    // reset on empty/invalid
    if (amountWei === 0n || amountWei === null) {
      setQuote(null);
      setError(null);
      setLoading(false);
      return;
    }

    const mySeq = ++seqRef.current;
    setLoading(true);
    setError(null);

    const t = setTimeout(async () => {
      try {
        const res = await quoter({
          token0,
          token1,
          fee,
          tickLower,
          tickUpper,
          amount0Desired: side === "0" ? amountWei ?? 0n : 0n,
          amount1Desired: side === "1" ? amountWei ?? 0n : 0n,
        });
        if (seqRef.current === mySeq) {
          setQuote(res);
          setLoading(false);
        }
      } catch (e) {
        if (seqRef.current === mySeq) {
          setQuote(null);
          setLoading(false);
          setError(e?.message || "quote failed");
        }
      }
    }, delay);

    return () => clearTimeout(t);
  }, [
    token0,
    token1,
    fee,
    tickLower,
    tickUpper,
    side,
    amountWei,
    delay,
    quoter,
  ]);

  return { quote, loading, error };
}
